export const PCI_PIPELINE_NUM_WEEKS = 10;
